
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 24 24","fill":"none"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M23.333 11.295a2.289 2.289 0 00.532-2.331 2.186 2.186 0 00-1.715-1.492l-5.392-.857a.498.498 0 01-.36-.283l-2.444-5.067a2.169 2.169 0 00-3.943 0L7.602 6.366a.497.497 0 01-.36.283l-5.392.857A2.186 2.186 0 00.135 8.998a2.289 2.289 0 00.532 2.332l3.9 3.969a.582.582 0 01.146.497l-.951 5.58a2.237 2.237 0 00.917 2.221 2.117 2.117 0 002.272.137l4.826-2.649a.395.395 0 01.412 0l4.826 2.65a2.134 2.134 0 002.272-.138 2.238 2.238 0 00.917-2.22l-.917-5.615a.582.582 0 01.145-.498l3.901-3.969zm-5.744 4.741l.926 5.615a.558.558 0 01-.214.549.403.403 0 01-.463 0l-4.827-2.623a2.143 2.143 0 00-2.057 0l-4.826 2.648a.42.42 0 01-.463 0 .558.558 0 01-.215-.548l.926-5.615a2.306 2.306 0 00-.617-1.972l-3.91-3.995a.575.575 0 01-.153-.591.497.497 0 01.377-.343l5.392-.815A2.203 2.203 0 009.12 7.103l2.408-5.143a.454.454 0 01.858 0l2.409 5.143a2.203 2.203 0 001.654 1.243l5.392.815a.497.497 0 01.377.343.574.574 0 01-.12.591l-3.909 3.97a2.307 2.307 0 00-.6 1.971z","fill":"currentColor"}})])
          )
        }
      }
    